import { Box } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';

export const Placeholder = ({ placeholder }: { placeholder?: string }) => {
  return (
    <Box sx={{ position: 'absolute', top: '0', left: '0' }}>
      <Typography variant="body" color={colors.grey[700]}>
        {placeholder}
      </Typography>
    </Box>
  );
};
